<div *ngIf="selectedActivity" class="activity-wrapper">
  <curbnturf-add-activity-form [activity]="selectedActivity" (close)="saved()"> </curbnturf-add-activity-form>
</div>
